;(function (window, $) {
	
	$.ajaxQ = (function(){
		var id = 0, Q = {}, prevent_abort = false;

		$(document).ajaxSend(function(e, jqx){
			jqx._id = ++id;
			Q[jqx._id] = jqx;
		});

		$(document).ajaxComplete(function(e, jqx){
			delete Q[jqx._id];
		});

		return {
			abortAll: function(){
				if(prevent_abort){
					return;
				}
				var r = [];

				$.each(Q, function(i, jqx){
					r.push(jqx._id);
					jqx.abort();
				});

				return r;
			},
			preventAbort: function(){
				prevent_abort = true;
			},
			enableAbord: function(){
				prevent_abort = false;
			}
		};

	})();

}(window, $));